import React from "react";

const Publications = () => {
  return (
    <div className='content'>
      INTERNATIONAL JOURNALS
      <hr />
      <ul>
        <li>
          2019 BUHAN, S., KUCUK, D., CINAR, M. S., GÜVENGIR, U., DEMIRCI, T.,
          YILMAZ, Y., ... & YILDIRIM, M. U. (2019). A SCALABLE RIVER FLOW
          FORECAST AND BASIN OPTIMIZATION SYSTEM FOR HYDROPOWER PLANTS. IEEE
          TRANSACTIONS ON SUSTAINABLE ENERGY.
        </li>
        <li>
          2019 CINAR, M. S., GENC, B., & SEVER, H. (2019). IDENTIFYING CRIMINAL
          ORGANIZATIONS FROM THEIR SOCIAL NETWORK STRUCTURES. TURKISH JOURNAL OF
          ELECTRICAL ENGINEERING & COMPUTER SCIENCES, 27(1), 421-436.
        </li>
        <li>
          2014 DOKEROGLU, T., OZAL, S., BAYIR, M. A., CINAR, M. S., & COSAR, A.
          (2014). IMPROVING THE PERFORMANCE OF HADOOP HIVE BY SHARING SCAN AND
          COMPUTATION TASKS. JOURNAL OF CLOUD COMPUTING, 3(1), 1-11.
        </li>
        <li>
          2014 DOKEROGLU, T., SERT, S. A., & CINAR, M. S. (2014). EVOLUTIONARY
          MULTIOBJECTIVE QUERY WORKLOAD OPTIMIZATION OF CLOUD DATA WAREHOUSES.
          THE SCIENTIFIC WORLD JOURNAL, 2014.
        </li>
      </ul>
      INTERNATIONAL CONFERENCES
      <hr />
      <ul>
        <li>
          2017 ÇİNAR M.S., GENÇ B., SEVER H., RAGHAVAN V.V., ANALYZING STRUCTURE
          OF TERRORIST NETWORKS BY USING GRAPH METRICS. 8TH IEEE INTERNATIONAL
          CONFERENCE ON BIG KNOWLEDGE.
        </li>
        <li>
          2016 DOKEROGLU, T., CINAR, M. S., SERT, S. A., & COSAR, A. (2016).
          IMPROVING HADOOP HIVE QUERY RESPONSE TIMES THROUGH EFFICIENT VIRTUAL
          RESOURCE ALLOCATION. INFLEXIBLE QUERY ANSWERING SYSTEMS 2015 (PP.
          215-225). SPRINGER INTERNATIONAL PUBLISHING.{" "}
        </li>
        <li>
          2014 DOKEROĞLU T., SERT S.A.,ÇİNAR M.S. ,COŞAR A. “DESIGNING CLOUD
          DATA WAREHOUSES USING MULTIOBJECTIVE EVOLUTIONARY ALGORITHMS” 6TH
          INTERNATIONAL CONFERENCE ON AGENTS AND ARTIFICIAL INTELLIGENCE (ICAART
          2014).{" "}
        </li>
        <li>
          2013 ÇINAR,M.S.,ÇİNAR I.,BILGE H.Ş. “ÖZGÜN BIR ŞIFRELEME ALGORITMASI
          KULLANAN GÜVENLİ E-POSTA UYGULAMASI”,(POSTER) 6TH INTERNATIONAL
          CONFERENCE ON INFORMATION SECURITY AND CRYPTOLOGY, ANKARA{" "}
        </li>
        <li>
          2011 ÇINAR M.S., ÇAKIR Ş. “TÜRKIYE’DE IPTV TEMELLI UZAKTAN EĞITIM”,
          INTERNATIONAL EDUCATIONAL TECHNOLOGY CONFERENCE,ISTANBUL
        </li>
      </ul>
      NATIONAL CONFERENCES
      <hr />
      <ul>
        <li>
          2022 D Küçük, S Buhan, T Demirci, MB Özkan, MS Çınar, E Altıntaş, ...
          . TEKİS: TEİAŞ Elektrik Güç Kalitesi ve Şebeke İzleme Sistemi, CIGRE
          Güç Sistemleri Konferansı
        </li>
        <li>
          2020 BUHAN S., KÜÇÜK D., ÇINAR MS., MALKOÇ F., YILDIRIM MU. AKIM
          TAHMIN VE HAVZA OPTİMİZASYON MODELİ (ATHOM) PROJESİ: GÜNCEL
          GELİŞMELER, ELEKTRIK İLETIM VE ÜRETIMINDE ENERJI VERIMLILIĞI
          SEMPOZYUMU
        </li>
        <li>
          2018 CINAR, M. S., GENC, B., & SEVER, H., THE USE OF SOCIAL NETWORK
          ANALYSIS IN DESTABILIZING OF TERRORIST ORGANIZATIONS, 9TH NATIONAL
          CONGRESS OF DEFENCE TECHNOLOGIES, METU, ANKARA, TURKEY
        </li>
        <li>
          2014 ÇİNAR I., ÇİNAR M.S.,BİLGE H.Ş. “ETKILEŞIMLI TELEVIZYON:IPTV”,
          AKADEMİK BİLİŞİM KONFERANSI 2014,MERSİN
        </li>
        <li>
          2014 ÇINAR M.S., BİLGE H.Ş.,”A NEW APPROACH IN BROADCASTING -
          DEVELOPMENT OF IPTV”, TRT 50TH ANNIVERSARY EVENTS-FROM ANALOG TO
          DIGITAL - COPYRIGHT ISSUES IN BROADCASTING AND NEW APPROACHES IN
          INTERNATIONAL LAW
        </li>
        <li>
          2014 ÇİNAR I., ÇİNAR M.S.,BİLGE H.Ş. “WEB SUNUCU LOGLARININ WEB
          MADENCILIĞI YÖNTEMLERI ILE ANALIZI”, AKADEMİK BİLİŞİM KONFERANSI
          2014,MERSİN
        </li>
        <li>
          2012 DOKEROĞLU T., COŞAR A., ÇİNAR M.S. “DAĞITIK ZINCIR BAĞLI
          BIRLEŞTIRME SORGULARININ PARALEL GENETIK ALGORITMALAR ILE
          OPTIMIZASYONU” 3. ULUSAL YÜKSEK BAŞARIMLI HESAPLAMA KONFERANSI,
          BİLKENT, ANKARA SEMPOZYUM
        </li>
      </ul>
    </div>
  );
};

export default Publications;
